// @flow
import React from "react";
import type { ErrorsType } from "../../conference/types/UserFormType";

import Banner from "@atlaskit/banner";
import ErrorIcon from "@material-ui/icons/Error";

type ErrorDisplayPropType = {
  errors: ErrorsType,
  form: string
};

export function setErrorMsg(errors: ErrorsType, errorType: string, errorMsg: string, isDelete: boolean = false): ErrorsType {
  if (isDelete) {
    delete errors[errorType];
  }
  else {
    errors[errorType] = errorMsg;
  }
  return errors;
}

export const checkEmail = (errors: ErrorsType, email: string): * => {
  if (email.trim() !== "") {
    const re = /^\w+([-+_=\.]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (!re.test(email)) {
      errors = setErrorMsg(errors,"email", "Email Format is NOT Correct.");
    }
    else {
      errors = setErrorMsg(errors, "email", "", true);
    }
  }
  return errors;
};

export const checkPassword = (errors: ErrorsType, pw1: string, pw2: string): * => {
  if (pw1 !== "" && pw2 !== "" && pw1 !== pw2) {
    errors = setErrorMsg(errors, "password", "New Password and Confirm Password don't match.");
  }
  else {
    errors = setErrorMsg(errors, "password", "", true);
  }
  return errors;
};

export const ErrosDisplay = (props: ErrorDisplayPropType): * => {
  if (Object.keys(props.errors).length > 0) {
    return (
      <Banner icon={<ErrorIcon className="inherit-icon" />} isOpen appearance="error" style={{ maxHeight: "100%" }}>
        {props.errors.credentials && <span>Your {props.form} credentials are invalid.<br /></span>}
        {props.errors.attempts && <span>Your number of {props.form} attempts has been exceeded. Please try again later.<br /></span>}
        {props.errors.email && <span>{props.errors.email === "uniqueness" ? "Email has already been registered." : props.errors.email}<br /></span>}
        {props.errors.termsagreed && <span>{props.errors.termsagreed}<br /></span>}
        {props.errors.access_token && <span>{props.errors.access_token}<br /></span>}
        {props.errors.info_edit && <span>{props.errors.info_edit}<br /></span>}
        {props.errors.image && <span>{props.errors.image}<br /></span>}
        {props.errors.form && <span>{props.errors.form}<br /></span>}
      </Banner>
    );
  }
  else {
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/global/components/ErrosDisplay.js